import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import Breadcrumbs from '../../modules/breadcrumbs';

import AboutUs from './about-us';
import Banner from './banner';
import Culture from './culture';
import Journey from './journey';
import Market from './market';
import Metrics from './metrics';
import AboutSchema from './seo';

const AboutPage: FunctionComponent<TPageContacts> = ({}) => {
  const { t } = useTranslation();

  return (
    <main>
      <AboutSchema breadcrumbs={[]} />
      <Breadcrumbs items={[]} currentPage={t('common:about')} />
      <Banner />
      <AboutUs />
      <Market />
      <Culture />
      <Metrics />
      <Journey />
    </main>
  );
};

export default AboutPage;
